import { makeAutoObservable } from 'mobx'

export type RequestDrawerModeType =
  | 'default'
  | 'status'
  | 'dealer'
  | 'payment-type'
  | 'installation-data'
  | 'request-info'
  | 'data'
  | 'images'
  | 'comment'

const withoutDefaultModes: RequestDrawerModeType[] = [
  'default',
  'data',
  'request-info',
  'images',
  'installation-data',
]

class RequestDrawerStore {
  mode: RequestDrawerModeType
  prevModes: RequestDrawerModeType[]
  withReportActions: boolean = false
  constructor() {
    this.mode = 'default'
    this.prevModes = []

    makeAutoObservable(this)
  }

  setMode = (mode: RequestDrawerModeType) => {
    if (!withoutDefaultModes.includes(mode)) {
      this.prevModes.push(this.mode)
    }
    this.mode = mode
  }

  goBack = (onExitCallback?: () => void) => {
    const prevMode = this.prevModes.pop()

    if (prevMode) {
      this.mode = prevMode
    } else {
      onExitCallback && onExitCallback()
    }
  }

  setWithReportActions = (value: boolean) => {
    this.withReportActions = value
  }
}

const requestDrawerStore = new RequestDrawerStore()
export default requestDrawerStore
